var map = {
	"./modules/group-sale-module/group-sale.module": [
		"./src/app/modules/group-sale-module/group-sale.module.ts",
		5
	],
	"./modules/halls-module/halls.module": [
		"./src/app/modules/halls-module/halls.module.ts",
		4
	],
	"./modules/multiple-performance/multiple-performance.module": [
		"./src/app/modules/multiple-performance/multiple-performance.module.ts",
		1
	],
	"./modules/reservation-create-module/reservation-create.module": [
		"./src/app/modules/reservation-module/modules/reservation-create-module/reservation-create.module.ts",
		3
	],
	"./modules/reservation-module/invitation.module": [
		"./src/app/modules/reservation-module/invitation.module.ts",
		8
	],
	"./modules/reservation-module/pool-invitation.module": [
		"./src/app/modules/reservation-module/pool-invitation.module.ts",
		0,
		7
	],
	"./modules/reservation-module/reservation.module": [
		"./src/app/modules/reservation-module/reservation.module.ts",
		0,
		6
	],
	"./modules/role-module/role.module": [
		"./src/app/modules/role-module/role.module.ts",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/i18n lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy
// module id = ./src/i18n lazy recursive
// module chunks = 9